import {React, useEffect, useState} from "react";
import '../App.css';
import logo from '../images/logo.png';
import horizontalLogo from '../images/horizontal-logo.png';
import nikar from '../images/nikar_blue.png';
import fashionist from '../images/fashionist.png';
import {Link, Route, Routes, useLocation} from 'react-router-dom';
import HomePage from "./tabs/HomePage";
import Dashboard from "./tabs/Dashboard";
import About from "./tabs/About";
import MenuBookIcon from '@mui/icons-material/MenuBook';
import TableChartIcon from '@mui/icons-material/TableChart';
import InfoIcon from '@mui/icons-material/Info';
import HomeIcon from '@mui/icons-material/Home';
import QueueMusicIcon from '@mui/icons-material/QueueMusic';
import { GrGallery } from "react-icons/gr";
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import {FaGraduationCap, FaPeopleLine} from "react-icons/fa6";
import WindowIcon from '@mui/icons-material/Window';


import {
    Box, Button,
    Divider,
    Drawer,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText
} from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import {initializeApp} from "firebase/app";
import {IoMdClose, IoMdPhotos} from "react-icons/io";
import Wadhamini from "./Wadhamini";
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import HandshakeIcon from '@mui/icons-material/Handshake';
import SettingsPhoneIcon from '@mui/icons-material/SettingsPhone';
import {FaChurch, FaNewspaper} from "react-icons/fa";
import {MdSafetyDivider} from "react-icons/md";
import Habari from "./Habari";
import Uongozi from "./Uongozi";
import Idara from "./Idara";
import Madhehebu from "./Madhehebu";
import Picha from "./Picha";
import Mawasiliano from "./Mawasiliano";
import {ImageOutlined} from "@mui/icons-material";
import Footer from "../widgets/Footer";



const firebaseConfig = {
    apiKey: "AIzaSyBUmGza9VgDZCl6pq3mU88-LW0iICHDXDc",
    authDomain: "the-cpct.firebaseapp.com",
    projectId: "the-cpct",
    storageBucket: "the-cpct.firebasestorage.app",
    messagingSenderId: "854259404298",
    appId: "1:854259404298:web:d9518ebb904a7f8d4159f3",
    measurementId: "G-PD6PF1HDQX"
  };

initializeApp(firebaseConfig);

export default function Home() {

    const mobileTitles = [
        "NYUMBANI", "KUHUSU CPCT", "UONGOZI", "IDARA", "MADHEHEBU", "WADHAMINI", "HABARI", "PICHA", "MAWASILIANO",
    ];

    const [activeTab, setActiveTab] = useState(0);
    const [tabTitle, setTabTitle] = useState(mobileTitles[activeTab]);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [isOffering, setIsOffering] = useState(false);

    const location = useLocation();

    useEffect(() => {
        const currentPath = location.pathname;
        let index = paths.findIndex(p => 
            p === currentPath || 
            (currentPath === '/' && p === '/') ||
            (currentPath.replace(/^\//, '') === p)
        );
        if (index !== -1) {
            setActiveTab(index);
            setTabTitle(mobileTitles[index]);
        }
    }, [location.pathname]);

    const menuIcons = [
        <HomeIcon/>,
        <HandshakeIcon />,
        <FaPeopleLine />,
        <MdSafetyDivider />,
        <FaChurch />,
        <TextSnippetIcon />,
        <FaNewspaper />,
        <IoMdPhotos />,
        <SettingsPhoneIcon />,
    ];

    // useEffect(() => {
    //     window.onscroll = function() {
    //         fixHeader();
    //     }
    // }, []);

    const paths = [
        '/', 'kuhusu-cpct', 'uongozi', 'idara', 'madhehebu', 'wadhamini', 'habari', 'picha', 'mawasiliano'
    ]

    const navItemStyle = {
        // color: 'white'
        fontFamily: 'Newsreader, serif'
    };


    // Mobile drawer
    const DrawerList = (
        <Box sx={{ width: 250 }} role="presentation" onClick={() => {
            setDrawerOpen(false);
        }}>
            <List>
                {mobileTitles.map((text, index) => {

                        return (
                            <Link  key={index} style={navItemStyle} to={paths[index]}>
                                <ListItem key={text} disablePadding>
                                    <ListItemButton onClick={() => {
                                        setActiveTab(index);
                                        setTabTitle(mobileTitles[index]);
                                    }}>
                                        <ListItemIcon>
                                            {menuIcons[index]}
                                        </ListItemIcon>
                                        <ListItemText primary={text}/>
                                    </ListItemButton>
                                </ListItem>
                            </Link>
                        )
                    }
                )}
            </List>
        </Box>
    );



    return (
        <div className="flex flex-col min-h-screen">
            <div className='navBar shadow-md'>
                <div className='flex justify-between w-full lg:max-w-5xl items-center pt-1'>
                    <Link to='/'>
                        <img src={horizontalLogo} alt="" width='90'/>
                    </Link>

                    <div className="tabs">
                        <Link to='/'>
                            <div className={"tabItem" + (activeTab === 0 ? " activeTab" : "")}
                                 onClick={() => setActiveTab(0)}>
                                Nyumbani
                            </div>
                        </Link>
                        <Link to='/kuhusu-cpct'>
                            <div className={"tabItem" + (activeTab === 1 ? " activeTab" : "")}
                                 onClick={() => setActiveTab(1)}>
                                Kuhusu CPCT
                            </div>
                        </Link>
                        <Link to='uongozi'>
                            <div className={"tabItem" + (activeTab === 2 ? " activeTab" : "")}
                                 onClick={() => setActiveTab(2)}>
                                Uongozi
                            </div>
                        </Link>
                        <Link to='idara'>
                            <div className={"tabItem" + (activeTab === 3 ? " activeTab" : "")}
                                 onClick={() => setActiveTab(3)}>
                                Idara
                            </div>
                        </Link>
                        <Link to='madhehebu'>
                            <div className={"tabItem" + (activeTab === 4 ? " activeTab" : "")}
                                 onClick={() => setActiveTab(4)}>
                                Madhehebu
                            </div>
                        </Link>
                        <Link to='wadhamini'>
                            <div className={"tabItem" + (activeTab === 5 ? " activeTab" : "")}
                                 onClick={() => setActiveTab(5)}>
                                Wadhamini
                            </div>
                        </Link>
                        <Link to='habari'>
                            <div className={"tabItem" + (activeTab === 6 ? " activeTab" : "")}
                                 onClick={() => setActiveTab(6)}>
                                Habari
                            </div>
                        </Link>

                        <Link to='picha'>
                            <div className={"tabItem" + (activeTab === 7 ? " activeTab" : "")}
                                 onClick={() => setActiveTab(7)}>
                                Picha
                            </div>
                        </Link>
                        <Link to='mawasiliano'>
                            <div className={"tabItem" + (activeTab === 8 ? " activeTab" : "")}
                                 onClick={() => setActiveTab(8)}>
                                Mawasiliano
                            </div>
                        </Link>

                    </div>
                </div>
            </div>


            {/* // MOBILE TAB */}
            <div className='mobileTabs shadow-sm' id='mobileTabs'>
                <div className='drawerController'>
                    <IconButton aria-label="delete" onClick={() => {
                        setDrawerOpen(true);
                    }}>
                        <MenuIcon color="var(--primary-color)"/>
                    </IconButton>
                    <div className='tabTitle'>{mobileTitles[activeTab]}</div>
                </div>

                <Link to='/'><img src={horizontalLogo} alt="" width='60'/></Link>
            </div>

            {/* App routes here! */}
            <div className="mainContainer h-full flex-1">
                <Routes>
                    <Route path="/" Component={HomePage}/>
                    <Route path="/kuhusu-cpct" Component={About}/>
                    <Route path="/habari" Component={Habari}/>
                    <Route path="/wadhamini" Component={Wadhamini}/>
                    <Route path="/mawasiliano" Component={Mawasiliano}/>
                    <Route path="/uongozi" Component={Uongozi}/>
                    <Route path="/idara" Component={Idara}/>
                    <Route path="/madhehebu" Component={Madhehebu}/>
                    <Route path="/picha" Component={Picha}/>
                    <Route index Component={HomePage}/>
                </Routes>
            </div>


            {/* OFFERING MODAL */}
            {isOffering ? <div className='modalOverlay'>
                <div className='modalBox'>
                    <div className='modalHeader'>
                        <h2 className='modalTitle'>&nbsp; Send your Offering (or Donation)</h2>
                        <button className='closeModalBtn' onClick={() => {
                            setIsOffering(false)
                        }}><IoMdClose size={25}/></button>
                    </div>

                    <div className='horizontalDivider'></div>
                    <div className='modalForm'>

                        <span className='hint'>Hamisha fedha kutoka kwenye akaunti yako ya Wito kwenda kwenye akaunti nyingine.</span>

                    </div>
                </div>
            </div> : <></>}


            <Drawer open={drawerOpen} onClose={() => setDrawerOpen(false)}>
                <div className="drawer">
                    <img src={logo} alt="" width='60'/>
                    {DrawerList}
                </div>
            </Drawer>

            <Footer />
        </div>
    )
}